<section class="page">
  <header class="page-header">
    <h2>Créer une chimie</h2>
  </header>

  <div *ngIf="success" class="success-toast">{{ success }}</div>
  <div *ngIf="error" class="error-toast">{{ error }}</div>

  <form (ngSubmit)="create()" #chimieForm="ngForm">
    <label for="nom">Nom de la chimie</label>
    <input id="nom" name="nom" [(ngModel)]="nom" required />
    <button type="submit" [disabled]="loading">Créer</button>
  </form>
</section>
